import { service } from '@/ajax/request'
export const getHourList = () => (
    service({
        url: `/ws-twelve-hour-manage/list`,
        method: 'POST',
    })
)

export const getHourDetailById = (params: any) => (
    service({
        url: `/ws-twelve-hour-manage/get-one`,
        method: 'POST',
        params,
    })
)

export const editHourDetail = (params: any) => (
    service({
        url: `/ws-twelve-hour-manage/create-or-update`,
        method: 'POST',
        params
    })
)

// 体重管理2.0 - 十二时辰体重管理指南
export const getWeigherTwelveHourGuideList = () => (
    service({
        url: `/weigher-twelve-hour-guide/list`,
        method: 'POST',
    })
)

export const getWeigherTwelveHourGuideDetail = (params: { id: number }) => (
    service({
        url: `/weigher-twelve-hour-guide/get-one`,
        method: 'POST',
        params,
    })
)

export const updateWeigherTwelveHourGuide = (params: {
    id: number
    mustDo: string
    mustDoDesc: string
    taboo: string
    tabooDesc: string
    fatLossCore: string
    fatLossPrinciple: string
}) => (
    service({
        url: `/weigher-twelve-hour-guide/update`,
        method: 'POST',
        params
    })
)